import { Checkbox } from 'antd';
import styled from 'styled-components';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { CredusText, color } from 'ui';

import { DeleteIcon } from '../../../../../assets/images/svgs';
import {
  CandidateDetails,
  TestCandidates,
} from '../../../../../contexts/CandidateContext';

interface CandidateUploadTableProps {
  candidateData: CandidateDetails;
  setCandidateData: React.Dispatch<React.SetStateAction<CandidateDetails>>;
  selectedCandidates: string[];
  setSelectedCandidates: React.Dispatch<React.SetStateAction<string[]>>;
}

const CandidateUploadTable = ({
  candidateData,
  setCandidateData,
  selectedCandidates,
  setSelectedCandidates,
}: CandidateUploadTableProps) => {
  const handleCheckAll = () => {
    const testCandidates = candidateData.Candidates.map((el) => el.regNo);
    setSelectedCandidates((prev) =>
      prev.length == testCandidates.length ? [] : [...testCandidates]
    );
  };

  const handleCheck = (e: CheckboxChangeEvent) => {
    setSelectedCandidates((prev) =>
      selectedCandidates?.includes(e.target.value)
        ? [...prev.filter((text) => text !== e.target.value)]
        : [...prev, e.target.value]
    );
  };

  const handleDelete = (regNo: string) => {
    const Candidates = candidateData.Candidates.filter(
      (candidate) => candidate.regNo !== regNo
    );
    setCandidateData((prev) => ({ ...prev, Candidates }));
  };
  return (
    <Table>
      <tr>
        <Th>
          <Checkbox onChange={handleCheckAll} />
        </Th>
        <Th>
          <CredusText size="md">#</CredusText>
        </Th>
        <Th>
          <CredusText size="md">ID</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Surname</CredusText>
        </Th>
        <Th>
          <CredusText size="md">First name</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Email Address</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Gender</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Mobile No</CredusText>
        </Th>
        {/* <Th>
          <CredusText size="md">Exam Cat</CredusText>
        </Th> */}
        <Th>
          <CredusText size="md">Subject</CredusText>
        </Th>
        <Th>
          <CredusText size="md">Action</CredusText>
        </Th>
      </tr>
      {candidateData?.Candidates.map((data: TestCandidates) => (
        <tr>
          <Td>
            <Checkbox
              onChange={handleCheck}
              value={data?.regNo}
              checked={selectedCandidates.includes(data?.regNo)}
            />
          </Td>
          <Td>
            <CredusText size="sm">#</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.regNo}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.surname}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.firstName}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.email}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.gender}</CredusText>
          </Td>
          <Td>
            <CredusText size="sm">{data?.phone}</CredusText>
          </Td>
          {/* <Td>
            <CredusText size="sm">Foundational</CredusText>
          </Td> */}
          <Td>
            <CredusText size="sm">{data?.registeredCourse}</CredusText>
          </Td>
          <Td>
            <TdDiv
              style={{ cursor: 'pointer' }}
              onClick={() => handleDelete(data?.regNo)}
            >
              <DeleteIcon />
              <CredusText size="sm" color={color.primary}>
                Delete
              </CredusText>
            </TdDiv>
          </Td>
        </tr>
      ))}
    </Table>
  );
};

export default CandidateUploadTable;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  background: #ffeae7;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;
const Td = styled.td`
  background: #fbfbfb;
  height: 58px;
  padding: 1rem 1.2rem;
  min-width: 44px;
`;

const TdDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  background: #fff6f4;
`;
